import React, { useState } from 'react';
import { Box, IconButton, Tooltip, Collapse, TextField, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import ThumbDownAltOutlinedIcon from '@mui/icons-material/ThumbDownAltOutlined';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';

const FeedbackContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(0.5),
}));

const FeedbackText = styled(Box)(({ theme }) => ({
  fontSize: '0.75rem',
  color: theme.palette.text.secondary,
  marginRight: theme.spacing(1),
}));

const FeedbackForm = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  padding: theme.spacing(1),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1),
}));

const FeedbackButtons = ({ messageId, onFeedback }) => {
  const [feedback, setFeedback] = useState(null);
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [feedbackText, setFeedbackText] = useState('');

  const handleFeedback = (isPositive) => {
    setFeedback(isPositive);
    
    if (!isPositive) {
      setShowFeedbackForm(true);
    } else {
      onFeedback(messageId, isPositive, '');
    }
  };

  const submitFeedback = () => {
    onFeedback(messageId, feedback, feedbackText);
    setShowFeedbackForm(false);
  };

  return (
    <>
      <FeedbackContainer>
        <FeedbackText>Was this helpful?</FeedbackText>
        <Tooltip title="Yes, this was helpful">
          <IconButton 
            size="small" 
            onClick={() => handleFeedback(true)}
            color={feedback === true ? 'success' : 'default'}
          >
            {feedback === true ? <ThumbUpIcon fontSize="small" /> : <ThumbUpAltOutlinedIcon fontSize="small" />}
          </IconButton>
        </Tooltip>
        <Tooltip title="No, this wasn't helpful">
          <IconButton 
            size="small" 
            onClick={() => handleFeedback(false)}
            color={feedback === false ? 'error' : 'default'}
          >
            {feedback === false ? <ThumbDownIcon fontSize="small" /> : <ThumbDownAltOutlinedIcon fontSize="small" />}
          </IconButton>
        </Tooltip>
      </FeedbackContainer>

      <Collapse in={showFeedbackForm}>
        <FeedbackForm>
          <TextField
            fullWidth
            size="small"
            placeholder="How can we improve this answer?"
            multiline
            rows={2}
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
            variant="outlined"
            margin="dense"
          />
          <Box display="flex" justifyContent="flex-end" mt={1}>
            <Button 
              size="small" 
              onClick={() => setShowFeedbackForm(false)}
              sx={{ mr: 1 }}
            >
              Cancel
            </Button>
            <Button 
              size="small" 
              variant="contained" 
              onClick={submitFeedback}
              disabled={!feedbackText.trim()}
            >
              Submit
            </Button>
          </Box>
        </FeedbackForm>
      </Collapse>
    </>
  );
};

export default FeedbackButtons;
